import { cn } from '@commenda/utils';
import React from 'react';

export interface DataGridStatePanelProps {
  children: React.ReactNode;
  className?: string;
}

const DataGridStatePanel = ({
  children,
  className,
}: DataGridStatePanelProps) => (
  <div
    className={cn(
      'sticky left-0 flex w-full items-center justify-center px-xl',
      className
    )}
  >
    {children}
  </div>
);

export { DataGridStatePanel };
